import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Label,
    Input,
    ButtonGroup,
    Col, CustomInput
} from 'reactstrap';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { API_Custom_Urls, gAPI_AllServices } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
const guestLifeCycleList = [
    { label: 'Pre Booking', value: 'Pre Booking', urlValue: 'PreBooking' },
    { label: 'Pre Check-in', value: 'Pre Check-in', urlValue: 'PreCheckedIn' },
    { label: 'At Property', value: 'At Property', urlValue: 'InHouse' },
    { label: 'After Check-out', value: 'After Check-out', urlValue: 'CheckedOut' },
    { label: 'Member Specific', value: 'Member Specific', urlValue: '' }
];

export default function URLParamSettings({
    pageSettings,
    saveIntegration,
    integration,
    propertyId,
    integrationProperties
}) {
    const dummyURL = process.env.REACT_APP_SERVICE_URL + "/info/" + "{ownURL}{source}{stage}{member}"
    const [lifeCycle, setLifeCycle] = useState(guestLifeCycleList);
    const [membershipGroupData, setMembershipGroupData] = useState([]);
    const [selectedMembershipGroup, setSelectedMembershipGroup] = useState([]);
    const [isMembershipGroup, setIsMembershipGroup] = useState(false);
    const [settings, setSettings] = useState({
        url: '',
        trackingCode: {
            isEnabled: false,
            membershipGroup: "",
            codeList: [""]
        },
    });
    const [inputData, setInputData] = useState({
        guestLifeCycle: [],
        membershipGroup: []
    });
    const [selectedCodes, setSelectedCodes] = useState([]);
    const [codeList, setCodeList] = useState([""]);
    const [ownurl, setOwnurl] = useState("");
    const [source, setSource] = useState("");
    const [stage, setStage] = useState("");
    const [member, setMember] = useState("");

    useEffect(() => {
        var url = "";
        var ownurl = "";
        var stages = "";
        var source = "";
        var memberss = "";
        if (pageSettings.seoSettings.ownUrl !== "") {
            ownurl = pageSettings.seoSettings.ownUrl;
            setOwnurl(ownurl);
        }
        if (pageSettings.urlParams !== undefined && pageSettings.urlParams !== null) {
            var codelist = [""];
            if (pageSettings.urlParams.trackingCode !== null &&
                pageSettings.urlParams.trackingCode.codeList !== null &&
                pageSettings.urlParams.trackingCode.codeList.length > 0) {
                pageSettings.urlParams.trackingCode.codeList.map((item, i) => {
                    codelist.push({ label: item, value: item, key: i });
                });
            }
            var selectedcode = [];
            if (pageSettings.urlParams.trackingCode !== null &&
                pageSettings.urlParams.trackingCode.membershipGroup !== null) {
                selectedcode = codelist.filter(i => i.value === pageSettings.urlParams.trackingCode.membershipGroup).map(m => m);
            }
            setSelectedCodes(selectedcode);
            setCodeList(codelist);
        }
        if (integrationProperties !== undefined) {
            let data = {
                languageCode: "en",
                propertyId: integrationProperties
            };
            AxiosAPI({
                method: 'post',
                url: `${gAPI_AllServices}`,
                data: data
            }).then((res) => {
                const serviceData = res.data.services.filter((item) => item.status === "Active");
                let servmember = [];
                serviceData.map((m) => {
                    if (m.membershipGroup !== null && m.membershipGroup.length > 0)
                        m.membershipGroup.map((n, i) => {
                            servmember.push({ label: n, value: n, key: servmember.length });
                        })
                });
                const unique = servmember.filter((obj, index) => {
                    return index === servmember.findIndex(o => obj.value === o.value);
                });
                setMembershipGroupData(unique);
                if (pageSettings !== undefined && pageSettings !== null) {
                    let selectedGuestLifeCycle = [];
                    if (pageSettings.guestLifeCycle !== null && pageSettings.guestLifeCycle.length > 0) {
                        selectedGuestLifeCycle = lifeCycle.map((elem, i) => {
                            var exist = pageSettings.guestLifeCycle.filter((item) => item === elem.value);
                            if (exist.length > 0) {
                                elem.checked = true;
                            } else {
                                elem.checked = false;
                            }
                            return {
                                ...elem,
                            };
                        });
                        setLifeCycle(selectedGuestLifeCycle);
                    }
                    const membershipGroup = selectedGuestLifeCycle.filter(i => i.checked === true && i.value === "Member Specific");
                    setIsMembershipGroup(membershipGroup.length > 0 ? true : false);
                    var selectedMemmbershipgroup = [];
                    if (pageSettings.membershipGroup != null && pageSettings.membershipGroup.length > 0) {
                        pageSettings.membershipGroup.map((item, i) => {
                            selectedMemmbershipgroup.push(servmember.filter((cat) => cat.value === item)[0]);
                        });
                    }
                    setSelectedMembershipGroup(selectedMemmbershipgroup);
                    if (pageSettings.guestLifeCycle.length > 0) {
                        pageSettings.guestLifeCycle.map((elem, i) => {
                            guestLifeCycleList.filter(l => l.value === elem).map(k => {
                                stages = stages + k.urlValue;
                                if (i < pageSettings.guestLifeCycle.filter(l => l !== "Member Specific").length - 1) {
                                    stages = stages + "|";
                                }
                            });
                        });
                        setStage(stages);
                    }
                    if (selectedMemmbershipgroup.length > 0) {
                        memberss = selectedMemmbershipgroup[0].label.replace(" ", "").toLowerCase();
                        setMember(memberss);
                    }
                    if (pageSettings.urlParams.trackingCode !== null &&
                        pageSettings.urlParams.trackingCode.membershipGroup !== null &&
                        pageSettings.urlParams.trackingCode.isEnabled === true) {
                        source = pageSettings.urlParams.trackingCode.membershipGroup;
                        setSource(source);
                    }
                    url = dummyURL.replace("{ownURL}", ownurl)
                        .replace("{source}", source === "" ? "?" : "?source=" + source)
                        .replace("{stage}", source === "" ? "stage=" + stages : "&stage=" + stages)
                        .replace("{member}", "&member=" + memberss);

                    setSettings({
                        ...settings,
                        url: pageSettings.urlParams.url === null ? url : pageSettings.urlParams.url,
                        trackingCode: pageSettings.urlParams.trackingCode === null ?
                            { isEnabled: false, membershipGroup: "", codeList: [""] } :
                            {
                                isEnabled: pageSettings.urlParams.trackingCode.isEnabled,
                                membershipGroup: pageSettings.urlParams.trackingCode.membershipGroup,
                                codeList: pageSettings.urlParams.trackingCode.codeList
                            },
                    });
                    setInputData({
                        guestLifeCycle: pageSettings.guestLifeCycle,
                        membershipGroup: pageSettings.membershipGroup
                    })
                }
            }).catch((err) => console.log('err', err));
        }
    }, [propertyId]);
    const handleSave = () => {
        pageSettings.urlParams = settings;
        pageSettings.guestLifeCycle = inputData.guestLifeCycle;
        pageSettings.membershipGroup = inputData.membershipGroup;
        saveIntegration({ PageSettings: pageSettings });
    };
    const checkedSource = (e) => {
        var setting = { ...settings };
        var val = { ...setting.trackingCode };
        val.isEnabled = e.target.checked;
        var source = "";
        if (e.target.checked === false) {
            setSource("");
        }
        else {
            setSource(val.membershipGroup.replace(" ", ""));
            source = val.membershipGroup.replace(" ", "");
        }
        var url = buildURL(ownurl, source, stage, member);
        setSettings({ ...settings, trackingCode: val, url: url });
    }
    const buildURL = (ownURL, sources, stages, members) => {
        var url = "";
        url = dummyURL.replace("{ownURL}", ownURL)
            .replace("{source}", sources === "" ? "?" : "?source=" + sources)
            .replace("{stage}", stages === "" ? "" : sources === "" ? "stage=" + stages : "&stage=" + stages)
            .replace("{member}", members === "" ? "" : "&member=" + members);
        return url;
    }
    const handleLifeCycleChange = (e) => {
        const values = lifeCycle.map((elem) => {
            if (elem.value === e.target.value) {
                elem.checked = !elem.checked;
            }
            return {
                ...elem,
            };
        });
        setLifeCycle(values);
        const lifecycleArr = values.filter((elem) => elem.checked === true).map((elem) => elem.value);
        setIsMembershipGroup(lifecycleArr.includes("Member Specific"));
        setInputData({
            ...inputData,
            guestLifeCycle: lifecycleArr,
        });
        var stageval = "";
        var cycle = lifecycleArr.filter(k => k !== "Member Specific");
        cycle.map((elem, i) => {
            guestLifeCycleList.filter(l => l.value === elem).map(k => {
                stageval = stageval + k.urlValue;
                if (i < cycle.length - 1) {
                    stageval = stageval + "|";
                }
            });
        });
        if (lifecycleArr.length === 0) { stageval = stage }
        setStage(stageval);
        var url = buildURL(ownurl, source, stageval, member);
        setSettings({
            ...settings, url: url
        });
    };
    const handleChangeCodeList = (selectedCodelist) => {
        setSelectedCodes(selectedCodelist);
        var setting = { ...settings };
        var trackingCode = { ...setting.trackingCode };
        var codelist = [];
        if (selectedCodelist !== null && selectedCodelist !== undefined) {
            codelist = selectedCodelist !== null && selectedCodelist !== undefined ? [selectedCodelist.value] : [];
            trackingCode.membershipGroup = selectedCodelist.value;
        }
        var sourceval = source;
        if (trackingCode.isEnabled === true) {
            sourceval = codelist;
            setSource(sourceval);
        }
        var url = buildURL(ownurl, sourceval, stage, member);
        setSettings({ ...settings, trackingCode: trackingCode, url: url });
    };
    const handleChangeMultiMembershipGroup = (selectedMembershipGroup) => {
        setSelectedMembershipGroup(selectedMembershipGroup);
        const membershipGroupArr = selectedMembershipGroup.map((elem) => elem.value);
        setInputData({
            ...inputData,
            membershipGroup: membershipGroupArr,
        });
        var stageval = "";
        if (membershipGroupArr.length > 0) {
            stageval = membershipGroupArr[0].replace(" ", "").toLowerCase();
        }
        setMember(stageval);
        var url = buildURL(ownurl, source, stage, stageval);
        setSettings({
            ...settings, url: url
        });
    };
    const AddSource = () => {
        var trackingCode = { ...settings.trackingCode };
        let links = [...trackingCode.codeList];;
        links.push("");
        trackingCode.codeList = links;
        var codelist = [];
        if (trackingCode.codeList.length > 0) {
            trackingCode.codeList.map((elem, i) => {
                codelist.push({ label: elem, value: elem, key: i })
            })
        }
        setCodeList(codelist);
        setSettings({ ...settings, trackingCode: trackingCode });
    };

    const RemoveSource = (index) => {
        var trackingCode = { ...settings.trackingCode };
        let values = [...trackingCode.codeList];;
        values.splice(index, 1);
        trackingCode.codeList = values;
        var codelist = [];
        if (trackingCode.codeList.length > 0) {
            trackingCode.codeList.map((elem, i) => {
                codelist.push({ label: elem, value: elem, key: i })
            })
        }
        setCodeList(codelist);
        setSettings({ ...settings, trackingCode: trackingCode });
    };
    const handleSourceChange = (e, index) => {
        var trackingCode = { ...settings.trackingCode };
        let values = [...trackingCode.codeList];
        values[index] = e.target.value;
        trackingCode.codeList = values;
        var codelist = [];
        if (trackingCode.codeList.length > 0) {
            trackingCode.codeList.map((elem, i) => {
                codelist.push({ label: elem, value: elem, key: i })
            })
        }
        setCodeList(codelist);
        setSettings({ ...settings, trackingCode: trackingCode });
    }
    const urlTextChange = (e) => {
        setSettings({ ...settings, url: e.target.value });
    }
    const handleGoToUrl = () => {
        handleSave();
        window.open(settings.url);
    }
    return (
        <Fragment>
            <Row>
                <Col className='col-md-12 mb-3'>
                    <Label className="mt-3"><b>Stage</b></Label>
                    <div className="row">
                        {lifeCycle.map((item, index) => (
                            <div className="col-md-6" key={index}>
                                <CustomInput
                                    type="checkbox"
                                    id={'guestLifeCycle' + index}
                                    value={item.value}
                                    label={item.label}
                                    checked={item.checked}
                                    onChange={handleLifeCycleChange}
                                />
                            </div>
                        ))}
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            {isMembershipGroup && (
                                <Fragment>
                                    <Label className="mt-3">Membership Group</Label>
                                    <Select
                                        components={{ Input: CustomSelectInput }}
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        isMulti={true}
                                        name="form-field-name"
                                        value={selectedMembershipGroup}
                                        onChange={handleChangeMultiMembershipGroup}
                                        options={membershipGroupData}
                                    />
                                </Fragment>
                            )}
                        </div>
                    </div>

                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <Label><b>Tracking Code (Source)</b></Label><br />
                            <span className='mt-3 mb-3'>Maintain list of Tracking Codes for reference </span>
                            {codeList !== null && codeList.length > 0 &&
                                codeList.map((k, i) => (
                                    <Row className="mb-3" key={i}>
                                        <Colxx md={6}>
                                            <Input
                                                type="text"
                                                id={k.value}
                                                value={k.value}
                                                name={"key~" + i}
                                                onChange={(e) => handleSourceChange(e, i)}
                                            ></Input>
                                        </Colxx>
                                        <Colxx md={6}>
                                            <Button color="danger" size="xs" outline onClick={() => RemoveSource(i)}>
                                                -
                                            </Button>
                                        </Colxx>
                                    </Row>
                                ))
                            }
                        </div>
                        <div className='col-md-12'>
                            <Button color="success" size="xs" outline onClick={AddSource}>
                                + Source
                            </Button>
                        </div>
                    </div>
                    <div className='row mb-3 mt-3'>
                        <div className='col-md-12  mb-3'>
                            <p>Pass source param to track where the QR Codes scans or URL clicks are happening from. Any value can be passed e.g. lobby, restaurant, room. </p>
                        </div>
                        <div className='col-md-3'>
                            <CustomInput
                                type="checkbox"
                                id={"source"}
                                label={"Source"}
                                checked={settings.trackingCode.isEnabled}
                                onChange={(e) => checkedSource(e)}
                            />
                        </div>
                        <div className='col-md-9'>
                            <Select
                                components={{ Input: CustomSelectInput }}
                                className="react-select ml-3"
                                classNamePrefix="react-select"
                                isMulti={false}
                                name="form-field-name"
                                value={selectedCodes}
                                onChange={handleChangeCodeList}
                                options={codeList}
                            />
                        </div>
                    </div>
                    <div className='row mb-3 mt-3'>
                        <div className='col-md-12'>
                            <Label><b>URL</b></Label>
                            <div class="input-icons-seo">
                                <Input
                                    className="input-field"
                                    type="textarea"
                                    id="url"
                                    value={settings.url}
                                    name="url"
                                    onChange={(e) => urlTextChange(e)}
                                ></Input>
                                <CopyToClipboard text={settings.url}>
                                    <FontAwesomeIcon icon={faCopy} className="fa icon" />
                                </CopyToClipboard>
                            </div>
                        </div>
                        <div className='col-md-12 mt-3'>
                            <div className='d-flex justify-content-left mb-3'>
                                <b className='mr-2 text-center'>
                                    <span style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" onClick={() => handleGoToUrl()}>
                                        Go To URL</span></b>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <div className='d-flex justify-content-center mb-2'>
                <ButtonGroup className="mb-2 text-center" style={{ marginTop: '40px' }}>
                    <Button color="primary" size="xs" outline onClick={handleSave}>
                        Save
                    </Button>
                </ButtonGroup>
            </div>
        </Fragment >
    );
}